import React, { useEffect, useState } from "react";
import { Button } from "../../components/Button";
import { EssentialIconsSendWrapper } from "../../components/EssentialIconsSendWrapper";
import { Logo } from "../../components/Logo";
import { SocialIcons } from "../../components/SocialIcons";
import "./style.css";
import { Link, Element } from "react-scroll";

export const LandiingPage = () => {
  const [formData, setFormData] = useState({
    fullName: "", country: "", company: "", jobTitle: "",
    email: "", phone: "", message: ""
  });

  // Scroll animation effect
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { root: null, rootMargin: '0px', threshold: 0.1 });

    document.querySelectorAll('.fade-in-section, .stagger-children').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Contact from ${formData.fullName} - ${formData.company}`);
    const body = encodeURIComponent(
      `Full Name: ${formData.fullName}\nCountry: ${formData.country}\nCompany: ${formData.company}\nJob Title: ${formData.jobTitle}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
    );
    window.location.href = `mailto:info@flowalytics.net?subject=${subject}&body=${body}`;
  };

  return (
    <div className="landiing-page">
      <div className="div-2">
        {/* ===== FOOTER ===== */}
        <footer className="footer">
          <div className="footer-big">
            <div className="company-info">
              <Logo />
              <div className="copyright">
                <div className="text-wrapper-4">Copyright © 2023 Flowalytics.</div>
                <div className="text-wrapper-5">All rights reserved</div>
              </div>
              <div className="social-links">
                <SocialIcons social="instagram" style="white" />
                <SocialIcons social="dribbble" style="white" />
                <SocialIcons social="twitter" style="white" />
                <SocialIcons social="youtube" style="white" />
              </div>
            </div>
            <div className="links">
              <div className="col">
                <div className="text-wrapper-6">Company</div>
                <div className="list-items">
                  <div className="text-wrapper-7">About us</div>
                  <div className="text-wrapper-8">Contact us</div>
                  <div className="text-wrapper-8">Pricing</div>
                  <div className="text-wrapper-8">Case Studies</div>
                  <div className="text-wrapper-8">Testimonials</div>
                </div>
              </div>
              <div className="col">
                <div className="text-wrapper-6">Support</div>
                <div className="list-items">
                  <div className="text-wrapper-7">Technical Support</div>
                  <div className="text-wrapper-8">Help center</div>
                  <div className="text-wrapper-8">Terms of service</div>
                  <div className="text-wrapper-8">Legal</div>
                  <div className="text-wrapper-8">Privacy policy</div>
                </div>
              </div>
              <div className="col-2">
                <div className="group">
                  <p className="p">
                    Cohive 101, Jl. DR. Ide Anak Agung Gde Agung, Kawasan Mega
                    Kuningan Jakarta Selatan, DKI Jakarta
                  </p>
                  <img className="map-pin" alt="Map pin" src="/img/map-pin.png" />
                </div>
                <div className="text-wrapper-9">Stay up to date</div>
                <div className="email-input-field">
                  <div className="overlap-group">
                    <div className="input-field-BG" />
                    <EssentialIconsSendWrapper />
                    <div className="text-wrapper-10">Your email address</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>

        {/* ===== MAIN CONTENT ===== */}
        <div className="overlap">
          <div className="frame-2">
            <div className="home">
              {/* ===== HERO ===== */}
              <Element name="home" className="element">
                <div className="hero-section">
                  <div className="overlap-2">
                    <div className="overlap-3">
                      <div className="frame-3">
                        <div className="text">
                          <p className="start-a-new">
                            <span className="text-wrapper-11">Start a new experience in </span>
                            <span className="text-wrapper-12">processing data</span>
                          </p>
                        </div>
                        <div className="hero-buttons">
                          <Button
                            className="button-instance"
                            divClassName="design-component-instance-node"
                            icon="no" size="small" state="default"
                            text="Register" type="primary"
                          />
                          <Button
                            className="button-instance"
                            divClassName="design-component-instance-node"
                            icon="no" size="small" state="default"
                            text="Contact Us" type="secondary"
                          />
                        </div>
                      </div>
                      <div className="ellipse-5" />
                      <div className="ellipse-6" />
                      <img className="vector" alt="Vector" src="/img/vector-8.svg" />
                      <img className="img" alt="Vector" src="/img/vector-9.svg" />
                      <img
                        className="https-lottiefiles"
                        alt="Analytics illustration"
                        src="/img/https-lottiefiles-com-animations-analytics-computer-omolhvxo13.gif"
                      />
                      <img className="group-2" alt="Group" src="/img/4.png" />
                      <div className="overlap-wrapper">
                        <div className="overlap-4">
                          <div className="rectangle" />
                          <div className="group-3">
                            <div className="overlap-group-wrapper">
                              <div className="overlap-group-2">
                                <img className="ellipse-7" alt="Ellipse" src="/img/ellipse-974.png" />
                                <img className="ellipse-8" alt="Ellipse" src="/img/ellipse-975-1.png" />
                                <img className="ellipse-9" alt="Ellipse" src="/img/ellipse-976-1.png" />
                                <img className="ellipse-10" alt="Ellipse" src="/img/ellipse-977-1.png" />
                              </div>
                            </div>
                            <div className="div-wrapper">
                              <div className="overlap-5">
                                <div className="text-wrapper-13">40k +</div>
                                <div className="companies">companies</div>
                              </div>
                            </div>
                          </div>
                          <div className="akar-icons-heart-wrapper">
                            <img className="akar-icons-heart" alt="Heart" src="/img/akar-icons-heart-1.svg" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Element>

              {/* ===== FLOWALYTICS DESCRIPTION (NEW) ===== */}
              <div className="flowalytics-description fade-in-section">
                <p className="flowalytics-desc-text">
                  <span className="text-wrapper-15">Flowalytics</span>
                  <span className="text-wrapper-14">— Financial Risk Analytics with Built-In Model Risk Management.</span>
                </p>
                <p className="flowalytics-desc-body">
                  Unify data ingestion, scenario management, forecasting, and stress testing into one
                  auditable workflow—so Risk, Accounting Finance, and Business can deliver consistent,
                  review-ready results with confidence.
                </p>
              </div>

              {/* ===== OUR VALUES (NEW) ===== */}
              <div className="our-values fade-in-section">
                <h2 className="our-values-title">Our Values</h2>
                <ol className="our-values-list">
                  <li>End-to-end stress testing from drivers to Profit &amp; Loss and Balance-Sheet impacts</li>
                  <li>Centralized assumptions &amp; scenario repository with traceability</li>
                  <li>Integrated forecasting and statistical and Machine Learning methods (transparent and configurable) through workflow</li>
                  <li>Strong governance: roles, approvals, audit trail, and controlled cycles</li>
                  <li>Results delivered through dashboards and report</li>
                  <li>Built in regulatory reporting data marts as required by regulator</li>
                </ol>
              </div>

              {/* ===== KEY BENEFITS & USE CASES (NEW) ===== */}
              <div className="benefits-usecases fade-in-section">
                <h2 className="benefits-title">Key Benefits &amp; Typical Use Cases</h2>
                <div className="benefits-grid">
                  <div className="benefits-col">
                    <h3 className="benefits-col-title">Key Benefits</h3>
                    <ol className="benefits-list">
                      <li>Reduce cycle time through standardized workflows and reusable scenario libraries</li>
                      <li>Improve defensibility with approvals, documentation, and audit-ready traceability</li>
                      <li>Increase consistency across teams and portfolios with controlled assumptions</li>
                      <li>Enable scalable "what-if" analysis without losing governance discipline</li>
                    </ol>
                  </div>
                  <div className="benefits-col">
                    <h3 className="benefits-col-title">Use Cases</h3>
                    <ol className="benefits-list">
                      <li>Enterprise stress testing</li>
                      <li>Recovery planning and impact quantification</li>
                      <li>Internal monitoring of model performance and assumption drift</li>
                      <li>Macro Economic Model Development</li>
                      <li>Credit growth and credit quality projections</li>
                      <li>Market/liquidity risk factor forecasting (interest rates, Foreign Exchange, yield curves)</li>
                      <li>Back-testing and model validation support packs</li>
                    </ol>
                  </div>
                </div>
              </div>

              {/* ===== OUR CLIENTS ===== */}
              <Element name="clients" className="element">
                <div className="clients fade-in-section">
                  <div className="clients-2">
                    <p className="section-title">
                      <span className="text-wrapper-14">Our </span>
                      <span className="text-wrapper-15">Clients</span>
                    </p>
                    <p className="description">We have been working with some extraordinary clients</p>
                  </div>
                  <div className="clients-logos">
                    <div className="clients-logos-2">
                      <img className="bank-smbc" alt="SMBC" src="/img/bank-smbc.png" />
                      {/* <img className="whatsapp-image-2" alt="Client" src="/img/whatsapp-image-2023-11-16-at-12-47-1.svg" />
                      <img className="download-removebg" alt="Client" src="/img/download-removebg-preview-1.png" />
                      <img className="bannner-depan" alt="Client" src="/img/bannner-depan-1.png" /> */}
                      <img className="tokyo-century" alt="Tokyo Century" src="/img/photo_2026-02-12_11-59-03.jpg" />
                      <img className="smfl" alt="SMFL" src="/img/smfl.png" />
                      <img className="clemont-finance" alt="Clemont" src="/img/clemont-finance.png" />
                      <img className="shinhan-indo-finance" alt="Shinhan" src="/img/shinhan-indo-finance.png" />
                      <img className="mbk" alt="MBK" src="/img/mbk.png" />
                    </div>
                  </div>
                </div>
              </Element>

              {/* ===== FEATURES ===== */}
              <div className="community">
                <div className="feature-wrapper fade-in-section">
                  <div className="feature">
                    {/* <div className="title">
                      <div className="feature-2">
                        <div className="text-wrapper-16">What advantages we offer?</div>
                      </div>
                    </div> */}
                    <p className="section-title-2">Solve more of your data problems with less code, less time</p>
                    <div className="content">
                      <div className="element">
                        <img className="icon" alt="Icon" src="/img/icon.png" />
                        <div className="content-2">
                          <div className="text-2">
                            <div className="text-wrapper-17">Simple and Less Code</div>
                            <p className="text-wrapper-18">Make it easier to process data because it does not require coding</p>
                          </div>
                        </div>
                      </div>
                      <div className="element-2">
                        <div className="content-3">
                          <div className="text-2">
                            <div className="text-wrapper-19">Self Service Analytics</div>
                            <p className="text-wrapper-18">can create their own analytical models, allowing business users to perform their own daily analytical tasks without involving the IT team</p>
                          </div>
                        </div>
                        <img className="icon-2" alt="Icon" src="/img/icon-1.png" />
                      </div>
                      <div className="element-3">
                        <div className="content-4">
                          <div className="text-2">
                            <div className="text-wrapper-19">Online Web Based</div>
                            <p className="text-wrapper-18">Can be accessed online, no installation required because it is web based</p>
                          </div>
                        </div>
                        <img className="icon-3" alt="Icon" src="/img/icon-2.png" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ===== ABOUT FLOWALYTICS ===== */}
            <div className="frame-4">
              <div className="unlock fade-in-section">
                <div className="unlock-2">
                  <img className="visual-data-pana" alt="Visual data" src="/img/visual-data-pana-1.svg" />
                  <div className="frame-5">
                    <div className="frame-6">
                      <p className="get-to-know">
                        <span className="text-wrapper-14">Get to know </span>
                        <span className="text-wrapper-15">Flowalytics</span>
                        <span className="text-wrapper-14"> in easy use of </span>
                        <span className="text-wrapper-15">Data Analysis</span>
                      </p>
                      <p className="when-joining-the">
                        <span className="text-wrapper-20">Flowalytics</span>
                        <span className="text-wrapper-21"> is a SaaS (Software as a Service) for analyzing, modeling, predicting and forecasting data with zero code (block based) so there is no need to learn programming languages to process data. </span>
                        <span className="text-wrapper-20">Flowalytics</span>
                        <span className="text-wrapper-21"> is our innovative solution designed to tackle this challenge head on by introducing a state of the art Low Code Data Analytics Tool.<br /><br /></span>
                        <span className="text-wrapper-22">keyword: Self Service Analytics, Low Code</span>
                      </p>
                    </div>
                    <Button className="button-instance" divClassNameOverride="design-component-instance-node" icon="no" size="medium" state="default" text="Learn More" type="primary" />
                  </div>
                </div>
              </div>

              {/* ===== STATISTICS (UPDATED NUMBERS) ===== */}
              <div className="users fade-in-section">
                <div className="asset">
                  <div className="overlap-group-3">
                    <img className="rectangle-2" alt="Rectangle" src="/img/rectangle-72.svg" />
                    <p className="helping-your-company">
                      <span className="text-wrapper-14">Helping your company</span>
                      <span className="text-wrapper-23"> to analyze data</span>
                    </p>
                    <div className="stats-row">
                      <div className="frame-7">
                        <div className="text-wrapper-24">2,245,341</div>
                        <div className="text-wrapper-25">Users</div>
                      </div>
                      <div className="frame-8">
                        <div className="text-wrapper-26">828,867</div>
                        <div className="text-wrapper-25">Study Case</div>
                      </div>
                      <div className="frame-9">
                        <div className="text-wrapper-27">46,328</div>
                        <div className="text-wrapper-28">Data Processed</div>
                      </div>
                    </div>
                    <img className="connected-world-pana" alt="Connected world" src="/img/connected-world-pana-1.svg" />
                  </div>
                </div>
              </div>

              {/* ===== CASE STUDIES (NEW) ===== */}
              <div className="case-studies fade-in-section">
                <h2 className="case-studies-title">
                  <span className="text-wrapper-15">Case studies that will make it easier </span>
                  <span className="text-wrapper-14">for you to understand the use of Flowalytics</span>
                </h2>
                <div className="case-study-card">
                  <div className="case-study-illustration">
                    <img src="/img/visual-data-pana-1.svg" alt="Case study illustration" />
                  </div>
                  <div className="case-study-content">
                    <p className="case-study-text">
                      Siemens, another industrial giant, embraces predictive maintenance through data science. They use machine learning algorithms to monitor and analyze data from their manufacturing machines. This approach allows Siemens to identify wear and tear patterns and schedule maintenance precisely when required.
                    </p>
                    <ul className="case-study-results">
                      <li>Siemens has reported a remarkable 20% reduction in planned downtime across its manufacturing facilities globally.</li>
                      <li>Siemens has achieved an overall equipment effectiveness (OEE) of 15% which increases production efficiency.</li>
                      <li>Siemens documented annual cost savings of $25 million in maintenance expenditures.</li>
                    </ul>
                  </div>
                </div>
                <div className="case-study-dots">
                  <span className="dot active"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </div>
              </div>

              {/* ===== TEAM (SINGLE ROW OF 5) ===== */}
              <Element name="team" className="element">
                <div className="group-wrapper fade-in-section">
                  <div className="team-section">
                    <div className="team-header">
                      <p className="our-expert-team">
                        <span className="text-wrapper-30">Our </span>
                        <span className="text-wrapper-23">expert team</span>
                      </p>
                      <p className="text-wrapper-31">We need talented, passionate people to changing the world</p>
                    </div>
                    <div className="team-grid">
                      <div className="team-row">
                        <div className="team-member">
                          <div className="overlap-group-4">
                            <img className="mask-group" alt="Alex Rudi" src="/img/mask-group-2.png" />
                            <div className="rectangle-5" />
                            <div className="frame-13">
                              <div className="text-wrapper-32">Alex Rudy</div>
                              <div className="text-wrapper-33">Financial Risk &amp; Analytics Practitioner</div>
                            </div>
                          </div>
                        </div>
                        <div className="team-member">
                          <div className="overlap-group-4">
                            <img className="mask-group" alt="Hazan" src="/img/mask-group-5.png" />
                            <div className="rectangle-5" />
                            <div className="frame-13">
                              <div className="text-wrapper-32">Hazan A. Zainuddin</div>
                              <div className="text-wrapper-33">Statistical Modeler</div>
                            </div>
                          </div>
                        </div>
                        <div className="team-member">
                          <div className="overlap-group-4">
                            <img className="mask-group" alt="Dr. Tugiantoro" src="/img/mask-group-4.png" />
                            <div className="rectangle-5" />
                            <div className="frame-13">
                              <div className="text-wrapper-32">Dr. Tugiantoro</div>
                              <div className="text-wrapper-33">Islamic Finance &amp; Sharia Banking Specialist</div>
                            </div>
                          </div>
                        </div>
                        <div className="team-member">
                          <div className="overlap-group-4">
                            <img className="mask-group" alt="Heru Wiryanto" src="/img/mask-group.png" />
                            <div className="rectangle-5" />
                            <div className="frame-13">
                              <div className="text-wrapper-32">Heru Wiryanto, Ph.D.</div>
                              <div className="text-wrapper-33">Senior AI Scientist</div>
                            </div>
                          </div>
                        </div>
                        <div className="team-member">
                          <div className="overlap-group-4">
                            <img className="mask-group" alt="Faisal" src="/img/mask-group-1.png" />
                            <div className="rectangle-5" />
                            <div className="frame-13">
                              <div className="text-wrapper-32">Faisal Wirakusuma</div>
                              <div className="text-wrapper-33">Machine Learning Engineer</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Element>

              {/* ===== CONTACT FORM (NEW) ===== */}
              <Element name="contact" className="element">
                <div className="contact-form-section fade-in-section">
                  <h2 className="contact-form-title">
                    <span className="text-wrapper-15">Contact Us</span>
                  </h2>
                  <p className="contact-form-subtitle">Get in touch with us for any inquiries or collaboration opportunities.</p>
                  <form className="contact-form" onSubmit={handleFormSubmit}>
                    <div className="form-row">
                      <div className="form-field">
                        <label>Full Name <span className="required">*</span></label>
                        <input type="text" name="fullName" value={formData.fullName} onChange={handleFormChange} required />
                      </div>
                      <div className="form-field">
                        <label>Country <span className="required">*</span></label>
                        <select name="country" value={formData.country} onChange={handleFormChange} required>
                          <option value="">Please Select</option>
                          <option value="Indonesia">Indonesia</option>
                          <option value="Singapore">Singapore</option>
                          <option value="Malaysia">Malaysia</option>
                          <option value="Japan">Japan</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label>Company <span className="required">*</span></label>
                        <input type="text" name="company" value={formData.company} onChange={handleFormChange} required />
                      </div>
                      <div className="form-field">
                        <label>Job Title <span className="required">*</span></label>
                        <input type="text" name="jobTitle" value={formData.jobTitle} onChange={handleFormChange} required />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label>Business Email <span className="required">*</span></label>
                        <input type="email" name="email" value={formData.email} onChange={handleFormChange} required />
                      </div>
                      <div className="form-field">
                        <label>Phone Number <span className="required">*</span></label>
                        <input type="tel" name="phone" value={formData.phone} onChange={handleFormChange} required />
                      </div>
                    </div>
                    <div className="form-field form-field-full">
                      <label>Message <span className="required">*</span></label>
                      <textarea name="message" rows="5" value={formData.message} onChange={handleFormChange} required></textarea>
                    </div>
                    <div className="form-actions">
                      <div className="recaptcha-placeholder">
                        <div className="recaptcha-checkbox"></div>
                        <span>I'm not a robot</span>
                      </div>
                      <button type="submit" className="contact-submit-btn">Contact Us</button>
                    </div>
                  </form>
                </div>
              </Element>
            </div>
          </div>
        </div>

        {/* ===== NAVBAR ===== */}
        <div className="nav-bar">
          <Logo className="logo-instance" />
          <div className="navbar">
            <Link offset={-60} to="home" style={{ cursor: "pointer" }} smooth={true} className="text-wrapper-37">Home</Link>
            <Link offset={-130} to="clients" style={{ cursor: "pointer" }} smooth={true} className="text-wrapper-37">Our Clients</Link>
            <Link offset={-50} to="solutions" style={{ cursor: "pointer" }} smooth={true} className="text-wrapper-37">Solutions</Link>
            <Link to="team" offset={-100} style={{ cursor: "pointer" }} smooth={true} className="text-wrapper-37">Our Team</Link>
            <Link to="contact" offset={-120} style={{ cursor: "pointer" }} smooth={true} className="text-wrapper-37">Contact Us</Link>
          </div>
        </div>
      </div>
    </div>
  );
};
